<template>
    <div>
        <!-- 头部 -->
        <v-header @pageSwitch="pageSwitch"></v-header>
        <div class="about-wrap">
            <!-- banner -->
            <img src="http://wx4.sinaimg.cn/large/0067mezugy1fj37acsagyj31hc0gon22.jpg" width="100%" class="banner" ref="top"/>
            <!-- 使用说明 -->
            <div class="box" ref="instructions">
                <div class="wrapCenter instructions">
                    <h2>使用说明</h2>
                    <div class="row">
                        <div class="col-xs-4" v-for="item in instructions">
                            <div class="circle-label"><i :class="item.icons"></i></div>
                            <p> {{ item.name }} </p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 煲机教程 -->
            <div class="box" ref="tutorial">
                <div class="wrapCenter tutorial">
                    <h2>煲机教程</h2>
                    <div class="row">
                        <div class="col-sm-12">
                            <p>为了在短时间内让耳机发挥出最好音效，唐麦研发团队依据耳机自身特点制定了一套特有的煲机方法，详情如下：</p>
                            <h3>第一阶段：</h3>
                            <p>使用唐麦提供的高品质无损音乐，每日循环播放3小时左右，音量调节为最大音量的2/3，如此持续一个星期；</p>
                            <h3>第二阶段：</h3>
                            <p>选择自己喜欢的歌曲，用适合自己的音量正常听歌，每天连续播放2-3小时，10天后，耳机音质就会逐渐趋于稳定。</p>
                        </div>
                    </div>
                    
                </div>
            </div>

            <!-- 无损音乐 -->
            <!-- <div class="box" ref="lossless">
                <div class="wrapCenter lossless">
                    <h2>无损音乐</h2>
                    <div class="row">
                        <div class="col-sm-12">
                            <p>好耳机更要听好音乐，掌柜私家珍藏<b>4000首无损音乐</b></p>
                            <img class="qr-code" src="../assets/img/qr-code.png" />
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- 防伪查询 -->
            <div class="box" ref="security">
                <div class="wrapCenter security">
                    <h2>防伪查询</h2>
                    <div class="row">
                        <div class="col-sm-5">
                            <div class="security-box">
                                <p><p class="p1">请刮开外包装上的防伪查询标签涂层，获取16位防伪码。</p>
                                <p class="p2">如图所示：</p>
                                <img src="../assets/img/security.png" >
                                <p class="p2">注意：<br>若外包装没有该标签或标签与上图不符，您所购买的产品可能不是唐麦正品，谨防假冒。您可以拨打我司客服热线400-037-0368进行确认。</p>
                            </div>
                            
                        </div>
                        <div class="col-sm-7">
                            <div class="security-box security-right">
                                <div class="col-sm-10">
                                    <img class="logo" src="../assets/img/logo_new.png" >
                                    <p>请依次输入16位防伪码进行查询</p>
                                    <input type="text" class="form-control" placeholder="请输入16位防伪码" v-model="code" maxlength="16">
                                    <div class="btn btn-danger btn-block" @click="querycode">立即查询</div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        <!-- 尾部 -->
         <v-footer @pageSwitch="pageSwitch"></v-footer>

          <!-- 回到顶部 -->
        <goto-top></goto-top>

        <!--唐麦防伪查询验证结果-->
       <div class="modal fade" id="modalQueryCode" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="security_result">
                    <div class="sr_title">唐麦防伪查询验证结果</div>
                    <div class="sr_box1" v-if="sr_type == 3">
                        <img src="http://ww4.sinaimg.cn/large/0067mezugw1f6b42ud4gvj3024024a9t.jpg" />
                        <p>您所查询的防伪码在正品防伪中心没有相关记录，谨防假冒。您可致电唐麦客服热线<span>400-037-0368</span>进行确认。</p>
                    </div>
                    
                    <div class="sr_box1" v-else-if="sr_type == 2">
                        <img src="http://ww4.sinaimg.cn/large/0067mezugw1f6b42u7nmoj30240243y9.jpg" />
                        <p>该防伪码已被重复查询，第一次查询时间为：{{ firstTime }}，如非本人操作，请致电唐麦客服热线400-037-0368进行确认。</p>
                    </div>
                    <div class="sr_box1" v-else>
                        <img src="http://ww4.sinaimg.cn/large/0067mezugw1f6b42tmsrkj3024024741.jpg" />
                        <p>该产品为唐麦官方正品，请您放心使用。谢谢您的支持！</p>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>
<script>
    import VHeader from "../components/header"
    import VFooter from "../components/footer"
    import jsonp from "jsonp"
    // 回到顶部
    import GotoTop from "../components/gotoTop"
    import {recordLog} from "../server/getData"
    export default{
        components:{
            VHeader,
            VFooter,
            GotoTop
        },
        data(){
            return {
                code: "",
                sr_type: 1,
                firstTime: "",
                instructions:[
                    {
                        name: "单按接听来电",
                        icons: "icon-answer"
                    },{
                        name: "长按拒接来电",
                        icons: "icon-dropped"
                    },{
                        name: "单击播放音乐",
                        icons: "icon-play"
                    },{
                        name: "单击暂停音乐",
                        icons: "icon-pause"
                    },{
                        name: "三击上一首音乐",
                        icons: "icon-previous"
                    },{
                        name: "双击下一首音乐",
                        icons: "icon-next"
                    }
                ]
            }
        },
        methods:{
            pageSwitch(){
                //获取要跳转的当前页面位置的id
                var path = this.$route.path.replace("/server/", "");
                //获取位置的坐标
                var top = this.$refs[path].offsetTop - 100;
                //跳转
                $('body, html').animate({
                    scrollTop: top
                }, 800);
            },
            querycode(){
                var self = this;
                if (this.code.length > 0) {
                var url = "http://china3-15.com/module/GetCode_getjson.ashx?action=add&key=2d5cc6c89b70845181414661ae0f4848&c=" + this.code;
                jsonp(url, null, function (err, data) {
                    if (err) {
                        console.error(err.message);
                    } else {
                        var res = data.result+"";
			    	    console.log(res);
                        //alert(res);
                        if(res.indexOf("不存在") >= 0){
                            self.sr_type = 3;
                            //console.log(3);
                        }else if(res.indexOf("已被查询过") >= 0){
                            self.sr_type = 2;
                            var time = res.split("时间为:");
                            if(time.length > 1){
                                time = time[1];
                            }
                            time = time.split(",");
                            if(time.length > 0){
                                time = time[0];
                            }
                            if(time != undefined && time != ""){
                                //$("#firstTime").text(time);
                                self.firstTime = time;
                            }
                            //console.log(2);
                        }else if(res.indexOf("唐麦官方正品") >= 0){
                            self.sr_type = 1;
                            //console.log(1);
                        }else{
                            self.sr_type = 1;
                        } 

                        $("#modalQueryCode").modal("show");
                        //将查询结果记录到日志
                        recordLog(self.code, res, self.sr_type);
                        //$(".security_result").show();
                        
                        // $(".cover2").show();
                        // if($(window).width() >= 600){
                        //     $(".security_result p").css("width", $(".sr_box1").outerWidth() - $(".sr_box1 img").outerWidth() - 12);
                        // }
                    }
                });
                }
            }
        },
        mounted(){
            $(document).ready(() => {
                this.pageSwitch();
            })
        }
    }
</script>
<style scoped>
    .circle-label{
        padding: 26px;
        width: 80px;
        height: 80px;
        margin: 0 auto;
    }

    .circle-label i{
        width: 100%;
        height: 100%;
        display: block;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center center;
    }

    .icon-answer{
        background-image:  url(../assets/img/icons/answer.png);
    }

    .icon-play{
        background-image:  url(../assets/img/icons/play.png);
    }
    .icon-pause{
        background-image:  url(../assets/img/icons/pause.png);
    }
    .icon-previous{
        background-image:  url(../assets/img/icons/previous.png);
    }
    .icon-next{
        background-image:  url(../assets/img/icons/next.png);
    }
    .icon-dropped{
        background-image:  url(../assets/img/icons/dropped.png);
    }

    .instructions .col-xs-4{
        margin-top: 20px;
    }

    .instructions p{
        text-align: center;
    }

    .tutorial h3{
        font-size: 18px;
        color: #848484;
    }

    .tutorial p{
        margin-bottom: 20px;
    }

    .lossless{
        text-align: center;
    }

    .lossless p{
        text-align: left;
    }

    .lossless p b{
        font-size: 22px;
        padding-left: 10px;
    }
    .qr-code{
        width: 160px;
    }

    .security-box{
        background: #eeeeee;
        border-radius: 8px;
        padding: 20px 16px;
        overflow: hidden;
        height: 100%;
        min-height: 374px;
        margin-top: 20px;
    }

    .security-box p{
        line-height: 24px;
        float: inherit;
    }

    .security-box p.p2{
        margin-top: 20px;
        line-height: 20px;
    }

    .security-box .logo{
        margin-top: 40px;
        width: 100px;
    }

    .security-box .form-control{
        background: #eeeeee;
        margin-top: 50px;
        padding: 14px 12px;
        height: 40px;
    }

    .security-box .btn-block{
        margin-top: 20px;
        background: #ad0000;
        padding: 14px 12px;
    }

    .security-right{
        padding: 40px 20px;
    }

    .security_result{ width: 88%; position: fixed; margin-left: 6%; height: 400px; background: #FFFFFF;
 margin-top: 60px; border-radius: 3px; z-index: 9; overflow: hidden;}
.sr_title{ background: #cecece; height: 40px; text-align: center; line-height: 42px; color: #515151;}
.security_result img{ width: 60px; margin: 0 auto; display: block; margin-bottom: 10px;}
.security_result p{ text-align: justify;/* margin-top: 30px;*/ line-height: 24px;}
.security_result p span{ white-space: nowrap;}
.security_result .sr_box1{
	 width: 70%; margin-left: 15%;
         top: 50%;
    margin-top: -70px;
    height: 60px;
    position: relative;
}
.sr_box1, .sr_box2, .sr_box3{ top: 50%; margin-top: -70px; height: 60px;}
	.security_result img{ float: left; margin-right: 10px;}
	.security_result p{ float: left;  width: 70%; display: block;left: 70px; top: 50%;
    }

    

    @media (max-width: 768px){
        .circle-label{
            padding: 1rem;
            width: 2.8rem;
            height: 2.8rem;
            margin-bottom: 10px;
        }

        .about-wrap .row{
            width: auto;
        }

        .about-wrap .row .col-xs-4{
            padding: 0 0.4rem;
        }

        .about-wrap .box p{
            font-size: 0.5rem;
        }

        .tutorial h3{
            font-size: 0.5rem;
        }

        .lossless p b{
            font-size: 0.5rem;
            font-weight: 400;
            padding-left: 0;
        }

        .qr-code{
            margin-top: 20px;
            width: 7rem;
        }

        .security_result{
            height: 300px;
        }

        .security-box .form-control{
            margin-top: 1rem;
        }

        .security-box .btn-block{
            font-size: 0.6rem;
            
        }
        .security_result img{
            float: none;
            margin: 0 auto;
            margin-bottom: 10px;
        }
        .security_result p{
            width: 100%;
            float: none;
            position: static;
            transform: none;
            margin-top: 0.8rem;
        }

        .security_result .sr_box1{
            margin-top: -106px;
        }

        .security-right{
            padding: 20px 16px;
            min-height: 280px;
        }

        .security-box .logo{
            margin-top: 20px;
            margin-bottom: 1rem;
        }
}
</style>


// WEBPACK FOOTER //
// src/pages/server.vue